import { cleanupSpaces } from '@/src/helpers/string'

export function classNames(...classes: (string | null | undefined)[]) {
  return cleanupSpaces(classes.filter(x => x).join(' '))
}
